import { ProfileConfig } from "./ProfileConfig";

class StepstoneConfig extends ProfileConfig {
  constructor(baseId: string, supportedLanguageKeys: Array<string>, target?: string) {
    super(baseId, supportedLanguageKeys, 'stepstone');
    this.ProfileId = `${baseId}`;
    this.ResourcePath = `${this.defaultPathPrefix}/${target ?? baseId}`;
  }
}

export { StepstoneConfig };
